package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Weather_partly_snowy_rainy: ImageVector
    get() {
        if (_weather_partly_snowy_rainy != null) {
            return _weather_partly_snowy_rainy!!
        }
        _weather_partly_snowy_rainy = Builder(name = "Weather_partly_snowy_rainy", defaultWidth =
                24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight =
                24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(13.55f, 2.66f)
                curveTo(13.0f, 2.42f, 12.45f, 2.26f, 11.88f, 2.15f)
                lineTo(14.37f, 0.84f)
                lineTo(15.27f, 3.73f)
                curveTo(14.76f, 3.31f, 14.19f, 2.95f, 13.55f, 2.66f)
                moveTo(6.09f, 3.46f)
                curveTo(5.6f, 3.81f, 5.17f, 4.21f, 4.8f, 4.66f)
                lineTo(4.91f, 1.84f)
                lineTo(7.87f, 2.53f)
                curveTo(7.25f, 2.73f, 6.65f, 3.05f, 6.09f, 3.46f)
                moveTo(18.0f, 8.73f)
                curveTo(17.91f, 8.15f, 17.78f, 7.57f, 17.59f, 7.03f)
                lineTo(19.97f, 8.53f)
                lineTo(17.92f, 10.76f)
                curveTo(18.03f, 10.1f, 18.05f, 9.42f, 18.0f, 8.73f)
                moveTo(3.04f, 10.32f)
                curveTo(3.11f, 10.92f, 3.25f, 11.5f, 3.43f, 12.03f)
                lineTo(1.06f, 10.53f)
                lineTo(3.1f, 8.3f)
                curveTo(3.0f, 8.95f, 2.97f, 9.64f, 3.04f, 10.32f)
                moveTo(16.68f, 22.21f)
                curveTo(16.68f, 23.2f, 15.91f, 24.0f, 14.95f, 24.0f)
                curveTo(14.0f, 24.0f, 13.23f, 23.2f, 13.23f, 22.21f)
                curveTo(13.23f, 21.03f, 14.95f, 19.03f, 14.95f, 19.03f)
                curveTo(14.95f, 19.03f, 16.68f, 21.03f, 16.68f, 22.21f)
                moveTo(6.03f, 21.45f)
                curveTo(5.93f, 21.07f, 6.15f, 20.68f, 6.54f, 20.58f)
                lineTo(8.13f, 20.15f)
                lineTo(6.96f, 19.0f)
                curveTo(6.68f, 18.72f, 6.68f, 18.27f, 6.96f, 18.0f)
                curveTo(7.23f, 17.7f, 7.7f, 17.7f, 8.0f, 18.0f)
                lineTo(9.14f, 19.14f)
                lineTo(9.55f, 17.56f)
                curveTo(9.65f, 17.17f, 10.05f, 16.94f, 10.43f, 17.05f)
                curveTo(10.82f, 17.15f, 11.05f, 17.55f, 10.93f, 17.93f)
                lineTo(10.5f, 19.5f)
                lineTo(12.1f, 19.1f)
                curveTo(12.5f, 19.0f, 12.88f, 19.21f, 13.0f, 19.6f)
                curveTo(13.08f, 19.97f, 12.86f, 20.37f, 12.47f, 20.47f)
                lineTo(10.89f, 20.89f)
                lineTo(12.05f, 22.05f)
                curveTo(12.33f, 22.32f, 12.33f, 22.79f, 12.05f, 23.07f)
                curveTo(11.77f, 23.35f, 11.31f, 23.35f, 11.03f, 23.07f)
                lineTo(9.87f, 21.9f)
                lineTo(9.45f, 23.5f)
                curveTo(9.35f, 23.88f, 8.95f, 24.1f, 8.57f, 24.0f)
                curveTo(8.18f, 23.9f, 7.97f, 23.5f, 8.06f, 23.12f)
                lineTo(8.5f, 21.55f)
                lineTo(6.91f, 21.96f)
                curveTo(6.5f, 22.06f, 6.13f, 21.84f, 6.03f, 21.45f)
                moveTo(19.0f, 15.03f)
                curveTo(18.65f, 15.03f, 18.31f, 15.08f, 18.0f, 15.19f)
                verticalLineTo(15.03f)
                curveTo(18.0f, 13.21f, 17.19f, 11.58f, 15.92f, 10.5f)
                curveTo(16.35f, 8.05f, 15.1f, 5.53f, 12.75f, 4.5f)
                curveTo(9.97f, 3.27f, 6.72f, 4.53f, 5.5f, 7.28f)
                curveTo(4.6f, 9.27f, 5.0f, 11.47f, 6.27f, 13.03f)
                horizontalLineTo(6.0f)
                curveTo(3.79f, 13.03f, 2.0f, 14.81f, 2.0f, 17.03f)
                curveTo(2.0f, 18.17f, 2.5f, 19.2f, 3.27f, 19.93f)
                verticalLineTo(19.93f)
                curveTo(3.27f, 19.93f, 3.97f, 20.64f, 4.68f, 19.93f)
                curveTo(5.39f, 19.22f, 4.68f, 18.5f, 4.68f, 18.5f)
                curveTo(4.27f, 18.15f, 4.0f, 17.62f, 4.0f, 17.03f)
                curveTo(4.0f, 15.92f, 4.9f, 15.03f, 6.0f, 15.03f)
                horizontalLineTo(8.0f)
                curveTo(8.0f, 12.81f, 9.79f, 11.03f, 12.0f, 11.03f)
                arcTo(4.0f, 4.0f, 0.0f, false, true, 16.0f, 15.03f)
                verticalLineTo(17.03f)
                horizontalLineTo(19.0f)
                arcTo(1.0f, 1.0f, 0.0f, false, true, 20.0f, 18.03f)
                curveTo(20.0f, 18.57f, 19.55f, 19.03f, 19.0f, 19.03f)
                horizontalLineTo(18.0f)
                curveTo(18.0f, 19.03f, 17.0f, 19.03f, 17.0f, 20.03f)
                curveTo(17.0f, 21.03f, 18.0f, 21.03f, 18.0f, 21.03f)
                horizontalLineTo(19.0f)
                arcTo(3.0f, 3.0f, 0.0f, false, false, 22.0f, 18.03f)
                curveTo(22.0f, 16.37f, 20.66f, 15.03f, 19.0f, 15.03f)
                moveTo(12.0f, 9.03f)
                curveTo(10.16f, 9.03f, 8.5f, 9.85f, 7.41f, 11.16f)
                curveTo(6.93f, 10.25f, 6.85f, 9.11f, 7.31f, 8.09f)
                curveTo(8.09f, 6.33f, 10.16f, 5.53f, 11.93f, 6.32f)
                curveTo(13.18f, 6.89f, 13.94f, 8.08f, 14.0f, 9.37f)
                curveTo(13.38f, 9.15f, 12.7f, 9.03f, 12.0f, 9.03f)
                close()
            }
        }
        .build()
        return _weather_partly_snowy_rainy!!
    }

private var _weather_partly_snowy_rainy: ImageVector? = null
